export const BASE_PROVIDER_PATH = '/providers';

export const INDEX_PROVIDER_PATH = `${ BASE_PROVIDER_PATH }/all`;
